(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
const localViewed = localStorage.recentlyViewedProduct;
function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts"));
  const fullContent = document.getElementsByClassName("recently-viewed-grid");
  const recentlyViewedHtml = [];
  const now = new Date();
  const nowTime = Math.floor(now.getTime() / 1000);
  
  if (productData === null) {
    document.querySelector(".recently-viewed-section").hidden = true;
  }

  productData.map(item => {
    recentlyViewedHtml.unshift(`
      <div class="swiper-slide">
        <div class="product-card position-relative">

          <a class="cover-link" href="${item.productUrl}">
            <span class="sr-only">${item.productTitle}</span>
          </a>
          <figure class="product-card__image">
            <img loading="lazy" height="500" width="500" src='${item.productImg}' alt="${item.productImageAltText}"/>
          </figure>
          <h3 class="text-base font-semibold font-heading text-contrast-darker mt-4">
            ${item.productTitle}
          </h3>
  
          <p class="text-base font-semibold font-heading text-contrast-darker mt-2">
            ${item.productPrice}
          </p>
        </div>
      </div>
    `);
  });

  const newProductData = `${recentlyViewedHtml.join("")}`;
  fullContent[0].innerHTML = newProductData;
  const newSwiper = new Moonbase.Swiper(".recently-viewed-swiper", {
    cssMode: true,
    slidesPerView: 1.25,
    spaceBetween: 10,
    pagination: {
      el: ".recently-viewed-pagination",
      clickable: true
    },
    navigation: {
      nextEl: '.recently-viewed-swiper-button-next',
      prevEl: '.recently-viewed-swiper-button-prev',
      clickable: true
    },
    breakpoints: {
      720: {
        slidesPerView: 2.25,
      },
      992: {
        slidesPerView: 3.25,
        pagination: {
          el: ".recently-viewed-pagination",
        },
        navigation: {
          nextEl: '.recently-viewed-swiper-button-next',
          prevEl: '.recently-viewed-swiper-button-prev',
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  getRecentlyViewedProducts();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-image-banner"] && !Shopify.designMode) return;
  try {
    
/* Add custom JavaScript code here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed"] && !Shopify.designMode) return;
  try {
    
    function getRecentlyViewedProducts() {
      const productData = JSON.parse(localStorage.getItem('recentlyViewedProducts'));

      if (productData === null || productData.length === 0) {
        document.querySelector('.recently-viewed-section').hidden = true;
        return;
      }

      const fetches = productData.map((el) => {
        return fetch(el.productUrl + '?sections=recent-product-card')
          .then((response) => response.json())
          .then((json) => {
            const parsed = json['recent-product-card'];
            const doc = new DOMParser().parseFromString(parsed, 'text/html');
            const card = doc.getElementById('recent-card');
            return card ? card.innerHTML : '';
          });
      });

      Promise.allSettled(fetches).then((results) => {
        const grid = document.getElementById('recently-viewed-grid');
        const htmls = results
          .filter((r) => r.status === 'fulfilled' && r.value)
          .map((r) => r.value);
        htmls.forEach((html) => grid.insertAdjacentHTML('beforeend', html));

        new Moonbase.Swiper('#recently-viewed-swiper', {
          loop: false,
          slidesPerView: 2,
          spaceBetween: 8,
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 13,
            },
          },
        });
      });
    }
    document.addEventListener('DOMContentLoaded', function (event) {
      getRecentlyViewedProducts();
    });
  
  } catch(e) { console.error(e); }
})();
})();
